import { Component } from "react";
import heapAnalytics from "../Services/HeapAnalyticsService";

// Rendered once at the top of the router (see App.js) so it re-renders on every
// navigation without remounting, letting us detect pathname changes reliably.
class HeapPageTracker extends Component {
  trackPageView(location) {
    heapAnalytics.trackEvent("Page View", {
      path: location.pathname,
      search: location.search,
    });
  }

  componentDidMount() {
    this.trackPageView(this.props.location);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.trackPageView(this.props.location);
    }
  }

  render() {
    return null;
  }
}

export default HeapPageTracker;
